import React from "react";
import { WynnCoverSheet } from "./CoverLetterWynn";
import { ResumeWynnPageOne, ResumeWynnPageTwo } from "./ResumeWynn";

/**
 * Wynn Al Marjan Island — Production Manager · Audio Visual
 * Job ID 1157 · Apply by 13 July 2026
 *
 * 3-page application pack:
 *   Page 1: Wynn-specific cover letter (Al Hamra Village hook)
 *   Page 2: Resume p1 (portable variant — no company name)
 *   Page 3: Resume p2
 *
 * Single PDF download via /api/application-wynn/pdf.
 */

const SANS = "Inter, -apple-system, BlinkMacSystemFont, sans-serif";

const ApplicationWynn = () => (
    <main
        data-testid="application-wynn-page"
        style={{
            backgroundColor: "#2a2620",
            minHeight: "100vh",
            padding: "40px 16px 80px",
            fontFamily: SANS,
        }}
    >
        <div
            className="application-toolbar"
            style={{
                maxWidth: 794,
                margin: "0 auto 24px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 12,
                flexWrap: "wrap",
            }}
        >
            <div>
                <p
                    style={{
                        color: "#c9a227",
                        fontSize: 11,
                        letterSpacing: "0.3em",
                        textTransform: "uppercase",
                        margin: 0,
                        fontWeight: 600,
                    }}
                >
                    Tatva K · Wynn Application Pack · 3 pages
                </p>
                <p
                    style={{
                        color: "#9a8c70",
                        fontSize: 10,
                        margin: "4px 0 0",
                        letterSpacing: "0.04em",
                    }}
                >
                    Production Manager — Audio Visual · Job ID 1157 · Apply by 13 July 2026
                </p>
            </div>
            <a
                href={`${process.env.REACT_APP_BACKEND_URL}/api/application-wynn/pdf`}
                download="Tatva-K-Wynn-Production-Manager-AV.pdf"
                data-testid="application-wynn-download-btn"
                style={{
                    backgroundColor: "#c9a227",
                    color: "#1a1a1a",
                    border: "none",
                    padding: "12px 26px",
                    fontSize: 11,
                    letterSpacing: "0.22em",
                    textTransform: "uppercase",
                    fontWeight: 700,
                    cursor: "pointer",
                    borderRadius: 999,
                    textDecoration: "none",
                    display: "inline-block",
                }}
            >
                Download PDF
            </a>
        </div>

        <WynnCoverSheet />
        <ResumeWynnPageOne />
        <ResumeWynnPageTwo />
    </main>
);

export default ApplicationWynn;
